import React, { useState } from 'react';
import './About.css';

export default function About() {
    const [myStyle, setMyStyle] = useState({
        color: 'white',
        backgroundColor: 'black'
    });

    const [btnTxt, setBtnText] = useState('Enable Light Mode'); // Fix the 'setBtnText' variable initialization

    const toggleStyle = () => {
        if (myStyle.color === 'white') {
            setMyStyle({
                color: 'black',
                backgroundColor: 'white'
            });
            setBtnText("Enable Dark Mode");
        } else {
            setMyStyle({
                color: 'white',
                backgroundColor: 'black',
                border: '1px solid white'
            });
            setBtnText("Enable Light Mode");
        }
    };

    return (
        <>
            <div className='container py-4' style={myStyle}>
                <h2 className='mb-4'>About TextAnalyzer</h2>

                <section className='mb-4'>
                    <h4>What is TextAnalyzer?</h4>
                    <p>
                        TextAnalyzer is a modern and efficient web-based utility designed to simplify text processing.
                        Whether you're a student, writer, or developer, TextAnalyzer helps you quickly analyze, modify,
                        and clean up your text with powerful built-in tools.
                    </p>
                </section>

                <section className='mb-4'>
                    <h4>Core Features</h4>
                    <ul>
                        <li>Convert text to UPPERCASE or lowercase instantly</li>
                        <li>Remove unwanted text with the clear button</li>
                        <li>Extract email addresses from raw text</li>
                        <li>Get live word and character counts</li>
                        <li>Estimate reading time for your content</li>
                        <li>Dark/Light Mode Toggle for better readability</li>
                    </ul>
                </section>

                <section className='mb-4'>
                    <h4>Why TextAnalyzer?</h4>
                    <p>
                        It's fast, responsive, and user-friendly. Built with React, TextAnalyzer leverages modern UI/UX
                        practices to provide a smooth experience. It’s perfect for proofreading, summarizing, or cleaning
                        any chunk of text before using it elsewhere.
                    </p>
                </section>

                <section className='mb-4'>
                    <h4>Behind the Project</h4>
                    <p>
                        Created by Pranav Mane as part of a learning initiative, this project combines frontend design
                        and logic using React hooks like <code>useState</code>. It showcases the ability to handle dynamic
                        styling, interactivity, and real-world use cases in a clean, maintainable format.
                    </p>
                </section>

                <button onClick={toggleStyle} type="button" className="btn btn-primary mt-3">
                    {btnTxt}
                </button>
            </div>
        </>
    );
}
